














































































































































































































































































































import {
  Vue,
  Component,
  Prop,
  Emit,
  PropSync,
  Watch,
  Inject,
  Ref,
} from "vue-property-decorator";
import Oficina from "@/models/orcamento-auto-online/Oficina";
import { ValidationObserver, ValidationProvider, validate } from "vee-validate";
import { VeiculoModel } from "@/models/orcamento-auto-online/VeiculoModel";
import { tiposPituraVeiculoList } from "@/models/orcamento-auto-online/TipoPinturaveiculo";
import orcamentoAutoModule from "@/store/orcamento-auto/OrcamentoAutoModule";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
  },
})
export default class AprovarModal extends Vue {
  $refs!: {
    aprovarObserver: InstanceType<typeof ValidationObserver>;
  };

  @Ref("oficinaValidationProvider")
  oficinaValidationProvider!: InstanceType<typeof ValidationProvider>;

  @PropSync("veiculo") veiculoSynced!: VeiculoModel;

  @PropSync("oficina") oficinaModal!: Oficina;

  @PropSync("oficinas") oficinasModal!: any;

  @PropSync("loading") loadingModal!: boolean;

  @Inject("mensagemErro")
  readonly mensagemErro!: string;

  oficinaHandle: Oficina = {};

  liberar = false;
  tiposPintura = tiposPituraVeiculoList;

  validar(): Promise<boolean> {
    return this.$refs.aprovarObserver.validate().then((valid) => {
      if (!this.mostrarDados()) {
        this.$refs.aprovarObserver.setErrors({
          oficina: "Campo oficina é obrigatório",
        });
      }
      return valid && this.mostrarDados();
    });
  }

  setOficinaError() {
    if (orcamentoAutoModule.mensagemOficina) {
      this.oficinaValidationProvider.setErrors([
        orcamentoAutoModule.mensagemOficina,
      ]);
    }
  }

  mounted() {
    this.setOficinaError();
  }

  mostrarDados() {
    if (this.oficinaModal == undefined) {
      this.oficinaModal = {
        CNPJ: "",
        DDD: "",
        cep: "",
        cidade: "",
        email: "",
        endereco: "",
        enderecoNr: "",
        nomeFantasia: "",
        oficinaCredenciamento: "",
        oficinaTipo: "",
        razaoSocial: "",
        responsavel: "",
        siglaEstado: "",
        telefone: "",
        bairro: "",
      };
    }
    let valid = this.oficinaModal.razaoSocial != undefined;
    valid = this.oficinaModal.razaoSocial != "" && valid;

    return valid;
  }
}
